import { Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { stateData } from '../content/stateDashContent';
const { Option } = Select;
import styles from '../styles/dashboard.module.less';
import DWChart from './DWChart';

type ControlsPropsType = {
  onStateChange: (state: string) => void;
};

interface StateCharts {
  charts: ChartType[];
  state: string;
}

interface ChartType {
  name: string;
  sources: Chart[];
}

interface Chart {
  name: string;
  url: string;
  id: string;
}

const DashboardControls: React.FC<ControlsPropsType> = (props) => {
  return (
    <Select
      defaultValue={stateData[0]}
      className={styles.stateDashboardControl}
      onSelect={props.onStateChange}
    >
      {stateData.map((state) => (
        <Option key={state}>{state}</Option>
      ))}
    </Select>
  );
};

const CountyDashboard: React.FC = () => {
  const [currState, setCurrState] = useState(stateData[0]);
  const [currChartSet, setCurrChartSet] = useState<StateCharts | undefined>(undefined);
  const [isError, setIsError] = useState(false);
  const [currChartType, setCurrCharType] = useState<number>(0);
  useEffect(() => {
    const fetchData = async (state: string) => {
      const state_key = state.toLowerCase().replaceAll(' ', '-');
      const res = await fetch(`/api/charts/states/${state_key}`);
      if (res.status != 200) {
        setIsError(true);
        return;
      }
      setCurrChartSet(await res.json());
      setIsError(false);
    };

    fetchData(currState).catch(console.error);
  }, [currState]);

  const handleStateChange = (value: string) => {
    setCurrState(value);
  };

  const handleChartTypeChange = (idx: number | string) => {
    setCurrCharType(idx as number);
  };

  const currChart = currChartSet ? currChartSet?.charts[currChartType] : null;
  const countyNameOptions = currChartSet
    ? currChartSet.charts.map((chart_type: ChartType, idx) => {
        return (
          <Option key={idx} label={chart_type.name}>
            {chart_type.name}
          </Option>
        );
      })
    : [];

  return (
    <div className={styles.dashboardTab}>
      <div className={styles.dropDowns}>
        <DashboardControls onStateChange={handleStateChange} />
        <Select
          className={styles.stateDashboardControl}
          onSelect={handleChartTypeChange}
          value={currChart?.name}
        >
          {countyNameOptions}
        </Select>
      </div>
      {isError ? (
        <p>Sorry there was an error loading the charts. Please refresh</p>
      ) : (
        <div className={styles.stateDashboard}>
          <DWChart
            className={styles.appIFrame}
            title={currChart?.name || ''}
            src={currChart?.sources[0].url || ''}
          />
          {currChart && currChart.sources.length > 1 ? (
            <>
              <DWChart
                className={styles.appIFrame}
                src={currChart.sources[1].url}
                title={currChart.name}
              />
            </>
          ) : (
            <></>
          )}
        </div>
      )}
    </div>
  );
};

export default CountyDashboard;
